var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.classNames.avatar, _vm.isOnline ? _vm.classNames.onlineStatus : _vm.classNames.offlineStatus]},[_c('img',{attrs:{"src":_vm.avatarPath}})])}
var staticRenderFns = []

export { render, staticRenderFns }